/*
 * Copyright © 2017-2021 Skale Education Inc. - All Rights Reserved
 */

import { useState } from "react";
import { Platform, TouchableOpacity, View } from "react-native";
import { info } from "react-icons-kit/feather/info";
import Icon from "react-icons-kit";

import { TimeWindowType } from "graphql/internal/generated";

import { Text } from "UpduoLibrary";
import { upduoPrimaryBlue } from "config/UpduoColors";
import {
  formattedTimeWindowTime,
  implementTimeZoneOffset,
} from "config/Utilities";
import * as UpduoAnalytics from "config/UpduoAnalytics";
import TimeWindowDescriptionModal from "components/SummitRoute/TimeWindowDescriptionModal";

export default function TimeWindow({
  timeWindowsList,
}: {
  timeWindowsList: Array<TimeWindowType>;
}) {
  const timeWindows = implementTimeZoneOffset(timeWindowsList);

  const [
    timeWindowDescriptionModalVisible,
    setTimeWindowDescriptionModalVisible,
  ] = useState(false);

  return (
    <View
      style={{
        backgroundColor: upduoPrimaryBlue,
        paddingHorizontal: 18,
        paddingVertical: 14,
        zIndex: 1,
      }}
    >
      <View style={{ display: "flex", flexDirection: "row", marginBottom: 4 }}>
        <Text isHeading={true} style={{ color: "white", fontSize: 16 }}>
          {"Upduo Time Windows:"}
        </Text>
        <TouchableOpacity
          style={{
            position: "absolute",
            right: 0,
          }}
          {...Platform.select({
            web: {
              onMouseEnter: () => {
                setTimeWindowDescriptionModalVisible(true);
                UpduoAnalytics.logEvent(
                  "user-summit-preview-hover-timewindow-banner-info-icon"
                );
              },
              onMouseLeave: () => {
                setTimeWindowDescriptionModalVisible(false);
              },
            },
          })}
        >
          <Text
            style={{
              color: "white",
            }}
          >
            <Icon size={20} icon={info} />
          </Text>
        </TouchableOpacity>
      </View>
      {timeWindows.map((timeWindow, index) => (
        <Text
          key={index}
          style={{ color: "white", fontSize: 16, marginBottom: 5 }}
        >
          {`${timeWindow.text}\n${formattedTimeWindowTime(timeWindow)}`}
        </Text>
      ))}

      <TimeWindowDescriptionModal
        isVisible={timeWindowDescriptionModalVisible}
        timeWindows={timeWindows}
      />
    </View>
  );
}
